import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";

import {
  LayoutDashboard,
  ShoppingBag,
  MapPin,
  UserRound,
  LockKeyhole,
  LogOut,
} from "lucide-react";

function Sidebar() {
  const navigate = useNavigate();

  const logOut = async () => {
    try {
      await userAPI.logOut();

      clearAccessToken();
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");

      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  const menuItems = [
    {
      to: "/users/dashboard",
      label: "Dashboard",
      icon: LayoutDashboard,
    },
    {
      to: "/users/orders",
      label: "My Orders",
      icon: ShoppingBag,
    },
    {
      to: "/users/addresses",
      label: "Addresses",
      icon: MapPin,
    },
    {
      to: "/users/account",
      label: "Account Details",
      icon: UserRound,
    },
    {
      to: "/users/change-password",
      label: "Change Password",
      icon: LockKeyhole,
    },
  ];

  return (
    <aside className="custom-profile-sidebar">
      {/* Sidebar Header */}
      <div className="custom-sidebar-heading">
        <div className="custom-sidebar-heading-icon">
          <UserRound size={18} />
        </div>

        <div>
          <span>MY ACCOUNT</span>
          <h5>Account Menu</h5>
        </div>
      </div>

      {/* Navigation */}
      <nav className="profile-nav-links">
        {menuItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `custom-sidebar-link ${isActive ? "active" : ""}`
              }
            >
              <span className="custom-sidebar-icon">
                <Icon size={18} strokeWidth={1.8} />
              </span>

              <span className="custom-sidebar-label">{item.label}</span>

              <span className="custom-sidebar-arrow">→</span>
            </NavLink>
          );
        })}

        {/* Logout */}
        <button
          type="button"
          className="custom-sidebar-link custom-sidebar-logout"
          onClick={(e) => logOut()}
        >
          <span className="custom-sidebar-icon">
            <LogOut size={18} strokeWidth={1.8} />
          </span>

          <span className="custom-sidebar-label">Logout</span>

          <span className="custom-sidebar-arrow">→</span>
        </button>
      </nav>
    </aside>
  );
}

export default Sidebar;
